<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <div>Display Name <span class="text-red">*</span></div>
        <v-text-field
          id="txtDisplayName"
          :model-value="modelValue.displayName"
          variant="solo"
          placeholder="Display Name"
          density="compact"
          :disabled="disabled || !editableName"
          :error-messages="displayNameErrors"
          @update:model-value="updateField('displayName', $event)"
          @blur="v$.modelValue.displayName.$touch()"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div>User Pool Client ID <span class="text-red">*</span></div>
        <v-text-field
          id="txtUserPoolClientId"
          :model-value="modelValue.userPoolClientId"
          variant="solo"
          placeholder="User Pool Client ID"
          density="compact"
          :disabled="disabled"
          :error-messages="userPoolClientIdErrors"
          @update:model-value="updateField('userPoolClientId', $event)"
          @blur="v$.modelValue.userPoolClientId.$touch()"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div>Organisation ID <span class="text-red">*</span></div>
        <v-text-field
          id="txtHubOrganisationId"
          :model-value="modelValue.organisationId"
          variant="solo"
          placeholder="Organisation ID"
          density="compact"
          :disabled="disabled"
          :error-messages="organisationIdErrors"
          @update:model-value="updateField('organisationId', $event)"
          @blur="v$.modelValue.organisationId.$touch()"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div>User Pool ID <span class="text-red">*</span></div>
        <v-text-field
          id="txtUserPoolId"
          :model-value="modelValue.userPoolId"
          variant="solo"
          placeholder="User Pool ID"
          density="compact"
          :disabled="disabled"
          :error-messages="userPoolIdErrors"
          @update:model-value="updateField('userPoolId', $event)"
          @blur="v$.modelValue.userPoolId.$touch()"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div>Cognito Domain <span class="text-red">*</span></div>
        <v-text-field
          id="txtCognitoDomain"
          :model-value="modelValue.cognitoDomain"
          variant="solo"
          placeholder="Cognito Domain"
          density="compact"
          :disabled="disabled"
          :error-messages="cognitoDomainErrors"
          @update:model-value="updateField('cognitoDomain', $event)"
          @blur="v$.modelValue.cognitoDomain.$touch()"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
  name: 'HubConfigForm',

  props: {
    modelValue: {
      type: Object,
      default: () => ({
        displayName: '',
        organisationId: '',
        userPoolId: '',
        userPoolClientId: '',
        cognitoDomain: ''
      })
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editableName: { type: Boolean, default: true }
  },

  emits: ['update:modelValue', 'update:valid'],

  setup: () => ({ v$: useVuelidate() }),

  computed: {
    displayNameErrors() {
      const errors = [];
      if (!this.v$.modelValue.displayName.$dirty) return errors;
      if (this.v$.modelValue.displayName.required.$invalid) {
        errors.push('Display Name is required');
      }
      return errors;
    },
    userPoolClientIdErrors() {
      const errors = [];
      if (!this.v$.modelValue.userPoolClientId.$dirty) return errors;
      if (this.v$.modelValue.userPoolClientId.required.$invalid) {
        errors.push('User Pool Client ID is required');
      }
      return errors;
    },
    organisationIdErrors() {
      const errors = [];
      if (!this.v$.modelValue.organisationId.$dirty) return errors;
      if (this.v$.modelValue.organisationId.required.$invalid) {
        errors.push('Organisation ID is required');
      }
      return errors;
    },
    userPoolIdErrors() {
      const errors = [];
      if (!this.v$.modelValue.userPoolId.$dirty) return errors;
      if (this.v$.modelValue.userPoolId.required.$invalid) {
        errors.push('User Pool ID is required');
      }
      return errors;
    },
    cognitoDomainErrors() {
      const errors = [];
      if (!this.v$.modelValue.cognitoDomain.$dirty) return errors;
      if (this.v$.modelValue.cognitoDomain.required.$invalid) {
        errors.push('Cognito Domain is required');
      }
      return errors;
    }
  },

  watch: {
    'v$.$invalid': {
      handler(invalid) {
        this.$emit('update:valid', !invalid);
      },
      immediate: true
    }
  },

  validations: {
    modelValue: {
      displayName: { required },
      organisationId: { required },
      userPoolId: { required },
      userPoolClientId: { required },
      cognitoDomain: { required }
    }
  },

  methods: {
    updateField(field, value) {
      this.v$.modelValue[field].$touch();
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [field]: value
      });
    },

    async validate() {
      this.v$.$touch();
      return !this.v$.$invalid;
    },

    resetValidation() {
      this.v$.$reset();
    }
  }
};
</script>
